import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _items: [],
  _item: {},
  _notiHistory: [],
  _page: {}, // { pageSize, totalCount, totalPage }
  _reviewCount: undefined,
  _rejectCount: undefined,
  _targetCount: undefined,
  _transferItems: [],
  _transferPage: {},
};

export const mutations = {
  setDobyList(state, item) {
    state._items = [];
    state._items = item.items;
    state._page = item.page;
  },
  setDobyCounts(state, item) {
    state._reviewCount = item.totalReviewCount;
    state._rejectCount = item.totalRejectCount;
    state._targetCount = item.todayTransferTargetCount;
  },
  setDobyDetail(state, item) {
    state._item = item;
  },
  setDobyNotiHistory(state, item) {
    state._notiHistory = item;
  },
  setDobyListTransfer(state, item) {
    state._transferItems = [];
    state._transferItems = item.items;
    state._transferPage = item.page;
  },
};

export const actions = {
  async acDobyList(
    { commit },
    { stdate, endate, page, pageSize, email, status }
  ) {
    const url = "/api/v1/doby/list";
    try {
      const res = await api.get(`${url}`, {
        params: { stdate, endate, page, pageSize, email, status },
      });
      if (res.data?.code === 0 && res.data.data) {
        const page = {
          pageSize: res.data.data.pageSize,
          totalCount: res.data.data.totalCount,
          totalPage: res.data.data.totalPage,
        };
        commit("setDobyList", {
          page: page,
          items: res.data.data.items,
        });
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyCounts({ commit }) {
    const url = "/api/v1/doby/counts";
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit("setDobyCounts", res.data.data);
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyDetail({ commit }, { doby_seq, user_no }) {
    const url = `/api/v1/doby/detail/${user_no}/${doby_seq}`;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit("setDobyDetail", res.data.data);
      }
    } catch (error) {
      return false;
    }
  },
  async acDobyNotiHistory({ commit }, { user_no }) {
    const url = `/api/v1/doby/noti-history/${user_no}`;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit("setDobyNotiHistory", res.data.data);
      }
    } catch (error) {
      return false;
    }
  },
  async acDobyListTransfer(
    { commit },
    { date, page, pageSize, email, dobyStatuses, transferStatuses }
  ) {
    const url = "/api/v1/doby/list/transfer";
    try {
      const res = await api.get(`${url}`, {
        params: {
          date,
          page,
          pageSize,
          email,
          dobyStatuses,
          transferStatuses,
        },
      });
      if (res.data?.code === 0 && res.data.data) {
        const page = {
          pageSize: res.data.data.pageSize,
          totalCount: res.data.data.totalCount,
          totalPage: res.data.data.totalPage,
        };
        commit("setDobyListTransfer", {
          page: page,
          items: res.data.data.items,
        });
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyUpdateStatus({ commit }, { doby_seq, user_no, status }) {
    const url = `/api/v1/doby/status/${user_no}/${doby_seq}`;
    try {
      const res = await api.patch(`${url}`, { status });
      window.console.log("acDobyUpdateStatus, res: ", res);
      return {
        success: res.data?.code === 0 && res.data?.data !== null,
        message: res.data?.message,
      };
    } catch (error) {
      window.console.log("acDobyUpdateStatus, error: ", error);
      return {
        success: false,
        message: error.data?.message,
      };
    }
  },
  async acDobyComment({ commit }, { user_no, doby_seq, comment }) {
    const url = `/api/v1/doby/comment/${user_no}/${doby_seq}`;
    try {
      const res = await api.post(`${url}`, { comment });
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyAddManualHistory(
    { commit },
    {
      admin_user_name,
      doby_seq,
      transfer_date,
      send_datetime,
      sender_name,
      owner_name,
      owner_bank_code,
      owner_account,
      transfer_amount,
      order_map_seq,
    }
  ) {
    const url = `/api/v1/doby/transfer/add/${doby_seq}`;
    try {
      const res = await api.post(`${url}`, {
        admin_user_name,
        transfer_date,
        send_datetime,
        sender_name,
        owner_name,
        owner_bank_code,
        owner_account,
        transfer_amount,
        order_map_seq,
      });
      return {
        success: res.data?.code === 0 && res.data?.data !== null,
        message: res.data?.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.data?.message,
      };
    }
  },
  async acDobyConnectManualHistory(
    { commit },
    {
      admin_user_name,
      doby_seq,
      transfer_date,
      send_datetime,
      sender_name,
      owner_name,
      owner_bank_code,
      owner_account,
      transfer_amount,
      order_map_seq,
    }
  ) {
    const url = `/api/v1/doby/transfer/connect/${doby_seq}`;
    try {
      const res = await api.post(`${url}`, {
        admin_user_name,
        transfer_date,
        send_datetime,
        sender_name,
        owner_name,
        owner_bank_code,
        owner_account,
        transfer_amount,
        order_map_seq,
      });
      return {
        success: res.data?.code === 0 && res.data?.data !== null,
        message: res.data?.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.data?.message,
      };
    }
  },
  async acDobyBalanceCheck() {
    const url = "/api/v1/doby/firm-banking/balance";
    try {
      const res = await api.post(`${url}`);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acDobyAutoTransfer() {
    const url = "/api/v1/doby/firm-banking/auto-transfer";
    try {
      const res = await api.post(`${url}`);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
